import { isSyncedTable, SYNCED_TABLES, TABLES } from '@tahi/db';
import type { SQLiteTable } from 'drizzle-orm/sqlite-core';

/** Only synced tables are written by mutations (history, outbox, sync_state, server tables never). */
export function tableFor(name: string): SQLiteTable {
  if (!isSyncedTable(name)) throw new Error(`${name} is not a synced table`);
  return (TABLES as Record<string, SQLiteTable>)[name] as SQLiteTable;
}

export function syncedTableNames(): string[] {
  return [...SYNCED_TABLES].sort();
}
